import React, { useEffect, useState } from 'react';
import Footer from '../Components/footer';
import BigNimar from '../Images/Nimar/shopzzz-1.jpg';
import smallNimar from '../Images/Nimar/nimar.png';
import x1 from '../Images/Nimar/1.jpg';
import x2 from '../Images/Nimar/2.jpg';
import x3 from '../Images/Nimar/3.jpg';
import x4 from '../Images/Nimar/4.jpg';
import x5 from '../Images/Nimar/5.jpg';
import x6 from '../Images/Nimar/6.jpg';
import xBg from '../Images/Nimar/IMG-20171214-WA0141.jpg';
import y1 from '../Images/Nimar/Nimar.jpg';
import { Link } from "react-router-dom";
import Logo from "../Images/Home/boat.png";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";

export default function Nimar(props) {

    const [User, SetUser] = useState('');

    useEffect(() => {
        onAuthStateChanged(props.auth, (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User
                SetUser(user);
                const uid = user.uid;
                // ...
                console.log("uid", uid)
            } else {
                // User is signed out
                // ...
                console.log("user is logged out")
            }
        });
    }, [])

    function signout() {
        signOut(props.auth).then(() => {
            window.location.reload(false);
            // Sign-out successful.
        }).catch((error) => {
            // An error happened.
        });
    }

    return (
        <div>
                        <nav className="navbar navbar-expand-lg navbar-dark nav-bg fixed-top">
                <div className="container-fluid">
                    <Link to="/" className="navbar-brand"><img src={Logo} alt="Logo" width="30" height="30" /></Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 navbar-nav-scroll">
                            <li className="nav-item">
                                <Link to="/" className="nav-link" aria-current="page">Home</Link>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle active" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Boats
                                </a>
                                <ul className="dropdown-menu">
                                    <li><Link to="/cechoii" className="dropdown-item">C-ECHO II</Link></li>
                                    <li><Link to="/nimar" className="dropdown-item">Nimar</Link></li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <Link to="/routes" className="nav-link">Routes</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/news" className="nav-link">News</Link>
                                </li>
                            {User !== '' ? <li className="nav-item">
                                <Link to="/contact" className="nav-link ">Book a boat</Link>
                            </li> : null}
                        </ul>
                        <ul className="navbar-nav navbar-nav-scroll">
                            {User !== '' ? <li className="nav-item">
                                <Link to="/bookings" className="nav-link">Bookings</Link>
                            </li> : null}
                            <li className="nav-item">
                                {User === '' ? <Link to="/login" className="nav-link">Login</Link> : null}
                            </li>
                            <li className="nav-item">
                                {User === '' ? <Link to="/signup" className="nav-link">Register</Link> : null}
                            </li>
                            <li>
                                {User !== '' ? <Link to="/" className="nav-link" onClick={signout}>Logout</Link> : null}
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <section>
                <div className="coverBigNimar"></div>
                <div className="titleFleet">
                    <h2> The Nimar</h2>
                </div>
            </section>
            <section style={{ paddingTop: '20px' }}>
                <article className="d-flex flex-column flex-lg-row justify-content-lg-around justify-content-center align-items-center pb-5">
                    <div className="p-3 text-black text-center">
                        <p className="p-2">
                            Our iron boat “Nimar” has facilities which make it the best one and the credentials of government organisation of marine safety ” champer diving water sports [ CDWS] “, Our boar is spacious to be comfortable and helps  you to move among different diving platforms and water areas.
                        </p>
                        <p className="p-2">
                            There are separated bathrooms, open areas of sun deck and high deck and a unique design for diving in the red sea.
                        </p>
                    </div>
                    <div style={{ backgroundImage: `url(${smallNimar})`, backgroundSize: 'auto' }} className="echo m-3">
                    </div>
                </article>
            </section>
            <section className="text-white" style={{ backgroundImage: `url(${xBg})`, backgroundSize: 'cover' }}>
                <article className="d-flex flex-column flex-lg-row align-items-center pb-5 px-5 py-5">
                    <div className="row row-cols-1 row-cols-md-3 g-4" style={{ color: 'black' }}>
                        <div className="col">
                            <div className="card h-100 " style={{ borderRadius: '20px' }}>
                                <img src={x1} className="card-img-top" alt="DOUBLE CABINS" style={{ borderRadius: '20px' }} />
                                <div className="card-body">
                                    <h5 className="card-title">DOUBLE CABINS</h5>
                                    <p className="card-text">The boat has 8 double cabins, equipped with air conditioning, minibar and bathroom with shower. Modern and spacious rooms designed for the comfort of each of our clients.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card h-100 " style={{ borderRadius: '20px' }}>
                                <img src={x2} className="card-img-top" alt="DIVING AREA" style={{ borderRadius: '20px' }} />
                                <div className="card-body">
                                    <h5 className="card-title">DIVING AREA</h5>
                                    <p className="card-text">The diving area stands out for its comfort and spaciousness, with charging stations for lights and cameras, common toilets, showers and fresh water containers and an exclusive space for each client.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card h-100" style={{ borderRadius: '20px' }}>
                                <img src={x3} className="card-img-top" alt="COMMON STAYS area" style={{ borderRadius: '20px' }} />
                                <div className="card-body">
                                    <h5 className="card-title">COMMON STAYS</h5>
                                    <p className="card-text">Most areas of the ship are common rooms, such as lounges, terrace, solariums, restaurant and diving area.Modern design, minimalist and clean, designed for the comfort of the group.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card h-100" style={{ borderRadius: '20px' }}>
                                <img src={x4} className="card-img-top" alt="RESTORATION area" style={{ borderRadius: '20px' }} />
                                <div className="card-body">
                                    <h5 className="card-title">RESTORATION</h5>
                                    <p className="card-text">The restaurant service is served in our restaurant lounge. A spacious stay, spread over the main restaurant where breakfast, lunch and dinner are served. High quality international food.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card h-100" style={{ borderRadius: '20px' }}>
                                <img src={x5} className="card-img-top" alt="SOLARIUMS" style={{ borderRadius: '20px' }} />
                                <div className="card-body">
                                    <h5 className="card-title">SOLARIUMS</h5>
                                    <p className="card-text">Two large solariums, one at the bow of the boat and another at the top are the area for sun-lovers and outdoor sailing. Areas designed for relaxation and recreation.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card h-100" style={{ borderRadius: '20px' }}>
                                <img src={x6} className="card-img-top" alt="Master Cabins" style={{ borderRadius: '20px' }} />
                                <div className="card-body">
                                    <h5 className="card-title">Master Cabins</h5>
                                    <p className="card-text">For all Families , the boat has Master cabins with King size beds 4 family rooms with one big bed and one small bed beside (can be used as a double or triple room) If you want to reserve one of the cabins, tell us when to make your reservation.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            </section>
            <section>
                <div className="d-flex container px-5 py-5">
                    <div className="row">
                        <div className="col-md-6" style={{ padding: '20px' }}>
                            <h1 style={{ marginBottom: '25px' }} className='titleHome'>Nimar specs</h1>
                            <p>
                                <span style={{ paddingTop: '2px' }}><strong>Year of building</strong> 2010 - 2012 <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Boat design category</strong> CE A (ocean) <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Port of registry</strong> Hurghada, Egypt <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Dimensions</strong> length 39,9 m, width 8,5 m <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Hull material</strong> 6-mm stainless steel covered by polymer; with additional anticorrosive protection <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Superstructures material</strong> wood <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Crew</strong> 10 persons : captain, mechanical engineer, chief cook, cook, two waiters, four sailors <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Engines</strong> two MAN by 1050 HP each <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Generators</strong> two DAEWOO by 120 kW each <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Compressors</strong> two Bauer with capability 250 l/min each <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Nitrox-blender</strong> yes <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Speedboats</strong> two with engines 40 HP each, one with engine 25 HP <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Safety equipment</strong> warning and fire extinguishing system; fire extinguishers; life jackets in each cabin; two <strong>safety rafts</strong> for 25 person each <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Desalination:</strong> Supply of fresh water 26 t, refilled by two water distillers MISTRAL with capability 1 tone/day each <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Navigation and communications</strong> VHF radio, DSC, GPS, radar, echo depth-sounder, satellite communication <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Number of decks</strong> 4 <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Number of passengers</strong> 24 <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Accommodation</strong>
                                    <br />8 standard cabins with two singl beds; 2 master cabins with double beds; 2 family rooms with one big bed and one small bed beside (can be used as a double or triple room) + 1 cabin downstairs for dive-guides. <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Cabin facilities</strong> minibar, conditioner, bathroom with shower cubicle <br />Restaurant facilities plasma TV, music mini system, DVD, cooler <br /></span>
                                <span style={{ paddingTop: '2px' }}><strong>Saloon facilities</strong> bar, cooler, wi-fi, plasma TV, music sound system, DVD</span>
                            </p>
                        </div>
                        <div className="col-md-6" style={{ padding: '20px' }}>
                            <div className="row">
                                <div className="col-md-12">
                                    <img src={y1} alt="nimar topview" className="img-fluid mb-3" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}